<template>
  <router-link tag="div" to="/my/data" class="flex pl15 pr15 pt10 pb10 flex-center">
    <div class="thumb flex0 mr15">
      <img :src="user|patAva" alt="" :data-gender="user.patGender" class="radius50">
    </div>
    <div class="info flex1">
      <h3 class="fs16">
        {{user.patName}}
<!--        <span :class="[isRealnameAuth?'color_main':'color_red']">{{isRealnameAuth?'已认证':'未认证'}}</span>-->
      </h3>
      <p class="fs14 color_666">{{user.patGender|getSex}} {{user.age}}岁</p>
    </div>
    <font class="flex0 iconfont color_999">&#xe72a;</font>
  </router-link>
</template>

<script>
  import {avaErrorMixin} from "../../lib/mixin";
  import patAva from "../../utils/patAva";
  import getSex from "../../utils/getSex";

  export default {
    name: "index-base-info",
    filters: {patAva, getSex},
    mixins: [avaErrorMixin],
    props: {
      user: {
        type: Object,
        default: () => Object.create(null)
      },
    },
    computed: {
      /*isRealnameAuth() {
        return this.user && this.user.sysCommonPatVo && this.user.sysCommonPatVo.isRealnameAuth;
      }*/
    },
  }
</script>

<style scoped lang="scss">
  @import "../../common/public";

  img {
    @include w_h(px2rem(60px), px2rem(60px));
  }
</style>



// WEBPACK FOOTER //
// src/plugins/my/index-base-info.vue